module.exports = __webpack_public_path__ + "static/media/Archive.42529b51.svg";